import React from 'react';

import { useIsSMBIncomplete } from '@/auth/hooks/useIsSMBIncomplete';
import { useAppSelector } from '@/store';

import { DashboardBody } from './DashboardBody';
import { SMBResumeSurface } from './SMBResumeSurface';

// SMB self-signup users who haven't finished team billing setup see a resume
// banner instead of the regular dashboard. The branch happens here, at the
// component-render boundary, so DashboardBody's data hooks never run for
// SMB-incomplete users. This was the gate the legacy Dashboard.tsx had
// (lines 120-157, byte-identical predicate) before the new dashboard
// (ENG-5146 + ENG-5130) replaced it. See ENG-5251 plan.
//
// signup_type is provenance, not current state — once an SMB user joins an
// enterprise team, hasTeamBilling flips true and isSMBIncomplete = false.
// Do not mutate signup_type on team join.
function DashboardPage(): React.ReactNode {
  const { isSMBIncomplete, pendingTeamMembership } = useIsSMBIncomplete();
  const viewer = useAppSelector((state) => state.viewer);

  if (isSMBIncomplete) {
    return <SMBResumeSurface viewer={viewer} pendingTeamMembership={pendingTeamMembership} />;
  }

  return <DashboardBody />;
}

export default DashboardPage;
